import React from "react";
import { IonCol } from "@ionic/react";
import TeamFormIcons from "./TeamFormIcons";
import { useTeamForm } from "../hooks/useTeamForm";

interface TeamWithFormProps {
  teamId: number;
  teamName: string;
  teamShort: string;
  size?: string;
  className?: string;
}

const TeamWithForm: React.FC<TeamWithFormProps> = ({
  teamId,
  teamName,
  teamShort,
  size = "5",
  className = "ion-text-center",
}) => {
  const { data: teamFormData, isLoading, error } = useTeamForm(teamId);

  return (
    <IonCol size={size} className={className}>
      <div>
        <strong style={{ fontSize: "13px", lineHeight: 1.25, display: "block" }}>
          {teamName || teamShort}
        </strong>
        {!isLoading &&
          teamFormData &&
          teamFormData.form &&
          teamFormData.form.length > 0 && (
            <TeamFormIcons teamId={teamId} formData={teamFormData.form} />
          )}
        {error !== null && error !== undefined && (
          <div style={{ fontSize: "10px", color: "red" }}>
            Error loading form
          </div>
        )}
      </div>
    </IonCol>
  );
};

export default TeamWithForm;
